import React from 'react';

 const Dropdown = () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.43301 7.25C4.24056 7.58333 3.75944 7.58333 3.56699 7.25L0.102886 1.25C-0.0895647 0.916666 0.150998 0.499999 0.535898 0.499999L7.4641 0.5C7.849 0.5 8.08957 0.916666 7.89712 1.25L4.43301 7.25Z" fill="#439ADE"/>
    </svg>
);

export default Dropdown